
import _ from 'lodash';
import { InputContainer } from '../../../../../common/components/form/form.module';


export const ProgramPlanComponent = ({
    selectedAssistancePlans,
    vehicleTypes,
    onFormPlanItemChange,
    handleDelete
}: any) => {

    return (
        <>

            {_.map(
                selectedAssistancePlans,
                (selectedAssistancePlan: any, index: any) => (
                    <div className=" grid md:grid-cols-3 lg:grid-cols-4 gap-4 border p-4">

                        <InputContainer
                            label="Name"
                            labelField="Name"
                            onValueChange={(event: any, newValue: any) => {
                                onFormPlanItemChange({
                                    value: event.target.value,
                                    field: 'Name',
                                    idx: index
                                });
                            }}
                            type="text"
                            value={selectedAssistancePlan?.Name}

                        />
                        <InputContainer
                            label="VehicleType Name"
                            labelField="Description"
                            list={vehicleTypes}
                            onValueChange={(event: any, newValue: any) => {
                                onFormPlanItemChange({
                                    value: event.target.value,
                                    field: 'VehicleType',
                                    idx: index
                                });
                            }}
                            optionName='Choose VehicleType'
                            type="select"
                            value={selectedAssistancePlan?.VehicleType}
                            valueField="Description"
                        />
                        <InputContainer
                            label="Program Duration"
                            onValueChange={(event: any, newValue: any) => {
                                onFormPlanItemChange({
                                    value: event.target.value,
                                    field: 'ProgramDuration',
                                    idx: index
                                });
                            }}
                            type="text"
                            value={selectedAssistancePlan?.ProgramDuration}

                        />
                        <InputContainer
                            label="Coverage Radius"
                            onValueChange={(event: any, newValue: any) => {
                                onFormPlanItemChange({
                                    value: event.target.value,
                                    field: 'CoverageRadius',
                                    idx: index
                                });
                            }}
                            type="text"
                            value={selectedAssistancePlan?.CoverageRadius}

                        />
                        <InputContainer
                            label="Number Of Service Annually"
                            onValueChange={(event: any, newValue: any) => {
                                onFormPlanItemChange({
                                    value: event.target.value,
                                    field: 'NumberOfServiceAnnually',
                                    idx: index
                                });
                            }}
                            type="number"
                            value={selectedAssistancePlan?.NumberOfServiceAnnually}

                        />
                        <InputContainer
                            label="Assistance Over Phone"
                            onValueChange={(event: any, newValue: any) => {
                                onFormPlanItemChange({
                                    value: event,
                                    field: 'IsAssistanceOverPhone',
                                    idx: index
                                });
                            }}
                            type="checkbox"
                            value={selectedAssistancePlan?.IsAssistanceOverPhone}

                        />
                        <InputContainer
                            label="Towing"
                            onValueChange={(event: any, newValue: any) => {
                                onFormPlanItemChange({
                                    value: event.target.value,
                                    field: 'Towing',
                                    idx: index
                                });
                            }}
                            type="text"
                            value={selectedAssistancePlan?.Towing}

                        />
                        <InputContainer
                            label="OnSite Minor Repairs"
                            onValueChange={(event: any, newValue: any) => {
                                onFormPlanItemChange({
                                    value: event,
                                    field: 'IsOnSiteMinorRepairs',
                                    idx: index
                                });
                            }}
                            type="checkbox"
                            value={selectedAssistancePlan?.IsOnSiteMinorRepairs}

                        />
                        <InputContainer
                            label="FlatTyre Assistance"
                            onValueChange={(event: any, newValue: any) => {
                                onFormPlanItemChange({
                                    value: event,
                                    field: 'IsFlatTyreAssistance',
                                    idx: index
                                });
                            }}
                            type="checkbox"
                            value={selectedAssistancePlan?.IsFlatTyreAssistance}

                        />
                        <InputContainer
                            label="Locked Key / Lost Key"
                            onValueChange={(event: any, newValue: any) => {
                                onFormPlanItemChange({
                                    value: event,
                                    field: 'IsLockedKey',
                                    idx: index
                                });
                            }}
                            type="checkbox"
                            value={selectedAssistancePlan?.IsLockedKey}

                        />
                        <InputContainer
                            label="Battery Support / Jumpstart"
                            onValueChange={(event: any, newValue: any) => {
                                onFormPlanItemChange({
                                    value: event,
                                    field: 'IsBatterySupport',
                                    idx: index
                                });
                            }}
                            type="checkbox"
                            value={selectedAssistancePlan?.IsBatterySupport}

                        />
                        <InputContainer
                            label="City Route And Map Guidance"
                            onValueChange={(event: any, newValue: any) => {
                                onFormPlanItemChange({
                                    value: event,
                                    field: 'IsCityRouteAndMapGuidance',
                                    idx: index
                                });
                            }}
                            type="checkbox"
                            value={selectedAssistancePlan?.IsCityRouteAndMapGuidance}

                        />
                        <InputContainer
                            label="Bike Taxi Benefits"
                            onValueChange={(event: any, newValue: any) => {
                                onFormPlanItemChange({
                                    value: event.target.value,
                                    field: 'BikeTaxiBenefits',
                                    idx: index
                                });
                            }}
                            type="text"
                            value={selectedAssistancePlan?.BikeTaxiBenefits}

                        />
                        <InputContainer
                            label="Relay On Messages"
                            onValueChange={(event: any, newValue: any) => {
                                onFormPlanItemChange({
                                    value: event,
                                    field: 'IsRelayOnMessages',
                                    idx: index
                                });
                            }}
                            type="checkbox"
                            value={selectedAssistancePlan?.IsRelayOnMessages}

                        />
                        <InputContainer
                            label="Medical Cordination"
                            onValueChange={(event: any, newValue: any) => {
                                onFormPlanItemChange({
                                    value: event,
                                    field: 'IsMedicalCordination',
                                    idx: index
                                });
                            }}
                            type="checkbox"
                            value={selectedAssistancePlan?.IsMedicalCordination}

                        />
                        <InputContainer
                            label="Accidental Legal Coordination"
                            onValueChange={(event: any, newValue: any) => {
                                onFormPlanItemChange({
                                    value: event,
                                    field: 'IsAccidentalLegalCoordination',
                                    idx: index
                                });
                            }}
                            type="checkbox"
                            value={selectedAssistancePlan?.IsAccidentalLegalCoordination}

                        />
                        <InputContainer
                            label="Dedicated 24/7 Helpline"
                            onValueChange={(event: any, newValue: any) => {
                                onFormPlanItemChange({
                                    value: event,
                                    field: 'IsDedicatedHelpline',
                                    idx: index
                                });
                            }}
                            type="checkbox"
                            value={selectedAssistancePlan?.IsDedicatedHelpline}

                        />
                        <InputContainer
                            label="Cooling Period"
                            onValueChange={(event: any, newValue: any) => {
                                onFormPlanItemChange({
                                    value: event.target.value,
                                    field: 'CoolingPeriod',
                                    idx: index
                                });
                            }}
                            type="text"
                            value={selectedAssistancePlan?.CoolingPeriod}

                        />
                        <InputContainer
                            label="Price"
                            onValueChange={(event: any, newValue: any) => {
                                onFormPlanItemChange({
                                    value: event.target.value,
                                    field: 'Price',
                                    idx: index
                                });
                            }}
                            type="number"
                            value={selectedAssistancePlan?.Price}

                        />
                        {selectedAssistancePlans.length > 1 && index !== 0 && (
                            <div className="w-[100px] space-x-2 flex justify-end">
                                <button
                                    onClick={() => handleDelete(selectedAssistancePlans, index)}
                                    className=" text-xs"
                                >
                                    <svg xmlns="http:www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM13.4142 13.9997L15.182 15.7675L13.7678 17.1817L12 15.4139L10.2322 17.1817L8.81802 15.7675L10.5858 13.9997L8.81802 12.232L10.2322 10.8178L12 12.5855L13.7678 10.8178L15.182 12.232L13.4142 13.9997ZM9 4V6H15V4H9Z"></path></svg>
                                </button>
                            </div>)
                        }


                    </div>
                ),
            )}
        </>
    )
}
export default ProgramPlanComponent;
